import { Button, Stack, Typography } from "@mui/material";
import { Dayjs } from "dayjs";

const DURATIONS_MINUTES = [20, 30, 45, 60, 90, 120];

interface IDurationButtonsProps {
  startTime: Dayjs | null;
  onSelect: (endTime: Dayjs) => void;
}

export const DurationButtons = ({
  startTime,
  onSelect,
}: IDurationButtonsProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      useFlexGap
      flexWrap="wrap"
      style={{ marginTop: -8 }}
    >
      <Typography variant="body2" color="text.secondary">
        Start +
      </Typography>
      {DURATIONS_MINUTES.map((minutes) => (
        <Button
          key={minutes}
          type="button"
          size="small"
          variant="outlined"
          disabled={!startTime}
          onClick={() => startTime && onSelect(startTime.add(minutes, "minute"))}
        >
          {minutes} mins
        </Button>
      ))}
    </Stack>
  );
};
